import moment, { Moment } from "moment";
export function formatDate(dateStr: string): string {
  if (dateStr) {
    const date = moment.utc(dateStr);
    if (date.isSameOrBefore('01 Jan 1970')) {
      return ''; // invalid date
    }
    return date.format('DD MMM YYYY');
  }
  else {
    return '';
  }
}

export const formatISODateOnly = (moment: Moment) => {
  return moment.format('yyyy-MM-DDT00:00:00Z')
};

// Use only for pattern matching, it will fail for invalid dates e.g. 2/31/2021
// could not use moment as moment will convert numbers to valid dates
export const isDate = (_date: string): boolean => {
  const _regExp = new RegExp('^\\d{4}-[0-1]\\d-[0-3]\\d(?:T[0-2]\\d:[0-5]\\d:[0-5]\\d([\\+\\-]\\d{2}:\\d{2}|Z)?)?$');
  return _regExp.test(_date);
}